export var ONEPASS_HERO_DEAL_REVAMP_EXPERIMENT = "onepass_hero_deal_revamp_nov_22";
export var ONEPASS_APP_SHOP_RECOMMENDER_EXPERIMENT = "club_shop_recommender_components_jun21";
export var ONEPASS_MIGRATION_MODAL_EXPERIMENT = "onepass_migration_popup_may_23";